
import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable()
export class DataService {

  private messageSource = new BehaviorSubject('default message');
  currentMessage = this.messageSource.asObservable();

  private userNameSource = new BehaviorSubject('');
  currentUserName = this.userNameSource.asObservable();

  constructor() { }

  saveEmailId(message: string) {
    this.messageSource.next(message);
  }

  saveUserName(message: string) {
    this.userNameSource.next(message);
  }

}
